var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInt3FaceLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 23,
    viewBox: "0 0 93 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 8.37695H2.32318V22.8179H0.34375V8.37695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.622 12.2363C11.8707 12.2363 12.871 12.6182 13.6229 13.382C14.3748 14.1457 14.7508 15.1804 14.7508 16.4859V22.8204H12.9021V16.5891C12.9021 15.7511 12.668 15.1013 12.2 14.6398C11.7319 14.1783 11.0861 13.9482 10.2625 13.9494C9.34004 13.9494 8.59527 14.2278 8.0282 14.7846C7.46114 15.3415 7.1773 16.1972 7.17667 17.3519V22.8186H5.32422V12.5024H7.17667V13.9874C7.92799 12.82 9.07643 12.2363 10.622 12.2363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1228 14.2376H20.2918V19.8283C20.2918 20.3369 20.3945 20.6988 20.6 20.9142C20.8054 21.1296 21.1219 21.2391 21.5495 21.2427C21.9753 21.2499 22.5003 21.2397 23.1247 21.2119V22.8209C21.5063 23.0272 20.3211 22.8999 19.5692 22.439C18.8172 21.9781 18.4413 21.1085 18.4413 19.8301V14.2376H16.332V12.5047H18.4394V10.1519L20.2918 9.61523V12.5038H23.1228V14.2376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4031 9.83948C38.5301 9.68866 37.5936 10.4729 37.5936 12.1923V12.5018H40.4031V14.2347H37.5936V22.8162H35.7403V14.2365H34.0391V12.5036H35.7403V12.1923C35.7403 10.8047 36.1408 9.7526 36.9419 9.0359C37.743 8.31919 38.8961 8.0097 40.4013 8.10744L40.4031 9.83948Z",
    fill: "white "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0446 12.5033H51.8924V22.8195H50.0446V21.0458C49.1221 22.4069 47.781 23.0874 46.0213 23.0874C44.5318 23.0874 43.262 22.5616 42.2119 21.5101C41.1618 20.4585 40.6367 19.176 40.6367 17.6623C40.6367 16.1493 41.1618 14.8667 42.2119 13.8145C43.262 12.7624 44.5318 12.2363 46.0213 12.2363C47.781 12.2363 49.1221 12.9171 50.0446 14.2788V12.5033ZM46.2557 21.3535C47.3338 21.3535 48.2364 20.9994 48.9634 20.2911C49.6905 19.5829 50.0524 18.706 50.0493 17.6605C50.0493 16.6156 49.6873 15.7387 48.9634 15.0299C48.2395 14.321 47.3369 13.9669 46.2557 13.9675C45.1913 13.9675 44.2974 14.3216 43.5741 15.0299C42.8508 15.7381 42.4889 16.615 42.4882 17.6605C42.4882 18.7054 42.8502 19.5823 43.5741 20.2911C44.298 21 45.1919 21.3541 46.2557 21.3535Z",
    fill: "white "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2889 23.086C57.6861 23.086 56.3524 22.5669 55.288 21.5286C54.2236 20.4903 53.6914 19.2011 53.6914 17.6609C53.6914 16.1207 54.2236 14.8315 55.288 13.7932C56.3524 12.755 57.6861 12.2355 59.2889 12.2349C60.2844 12.2207 61.2644 12.4744 62.1199 12.9679C62.9325 13.4295 63.5846 14.1154 63.9929 14.938L62.4392 15.804C62.169 15.2538 61.7357 14.7941 61.1946 14.4837C60.6192 14.1502 59.9593 13.9787 59.2889 13.9887C58.2251 13.9887 57.3347 14.3395 56.6176 15.0411C55.9005 15.7428 55.5423 16.616 55.5429 17.6609C55.5429 18.6925 55.9012 19.5589 56.6176 20.2599C57.3341 20.9609 58.2245 21.3117 59.2889 21.3123C59.9611 21.3217 60.6233 21.1541 61.2049 20.8273C61.757 20.5208 62.2075 20.0682 62.5036 19.5224L64.0788 20.4092C63.6232 21.2217 62.9446 21.8964 62.118 22.3584C61.2609 22.8461 60.2827 23.0977 59.2889 23.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0613 18.4863C67.2481 19.4075 67.6838 20.1227 68.3685 20.6319C69.0532 21.141 69.9013 21.3953 70.9128 21.3947C72.3171 21.3947 73.3386 20.8928 73.9772 19.8889L75.5524 20.7549C74.5172 22.3096 72.9564 23.0866 70.8699 23.086C69.1811 23.086 67.8083 22.5732 66.7513 21.5477C65.6944 20.5221 65.1653 19.225 65.1641 17.6564C65.1641 16.1024 65.6823 14.8095 66.7187 13.7779C67.7551 12.7463 69.0959 12.2305 70.741 12.2305C72.3022 12.2305 73.5757 12.7635 74.5617 13.8295C75.5477 14.8955 76.041 16.1781 76.0416 17.6773C76.041 17.9466 76.0194 18.2155 75.9772 18.4817L67.0613 18.4863ZM70.7438 13.9272C69.7479 13.9272 68.925 14.1987 68.2751 14.7417C67.6253 15.2846 67.2207 16.0101 67.0613 16.918H74.1705C74.0149 15.9413 73.6177 15.1986 72.9791 14.6901C72.3518 14.1854 71.559 13.9148 70.7438 13.9272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9016 16.3904L31.8493 13.9977V12.5254H25.1893V14.2131H29.5431L27.3368 16.9387L28.0389 17.9885H28.5179C29.0781 17.9885 29.5449 18.1287 29.9007 18.4038C30.0678 18.5609 30.2006 18.749 30.2912 18.9568C30.3819 19.1647 30.4285 19.3881 30.4282 19.6137C30.4265 19.8566 30.3714 20.0964 30.2666 20.317C30.1618 20.5377 30.0097 20.7341 29.8204 20.8933C29.6305 21.0596 29.4032 21.1808 29.1565 21.2471C28.8322 21.3249 28.4953 21.3403 28.1649 21.2924C27.7882 21.2374 27.437 21.0744 27.1566 20.8245C26.98 20.6577 26.8344 20.4628 26.7261 20.2481C26.6449 20.0915 26.4647 19.6508 26.46 19.6508L24.9297 20.5684C25.0733 21.0791 25.3483 21.5462 25.7289 21.9258C26.1544 22.3464 26.6785 22.6612 27.2565 22.8434C27.6939 22.9832 28.1516 23.0538 28.6122 23.0525C30.6355 23.0525 32.276 21.5141 32.276 19.6083C32.276 18.136 31.2882 16.8808 29.9016 16.3904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3324 10.3984H83.6116C83.6116 10.3984 82.2708 13.0282 82.2745 13.0282C82.2783 13.0282 81.0673 10.5849 81.0673 10.5849C81.0271 10.5007 81.2512 10.3975 81.3324 10.3984Z",
    fill: "url(#paint0_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5136 13.9396L82.7124 13.907L81.155 10.7352C81.0421 10.5225 80.747 10.5479 80.6368 10.7614L79.1924 13.3414C79.0542 13.6093 79.2316 13.9396 79.5136 13.9396Z",
    fill: "url(#paint1_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6289 10.7724C80.6289 10.7724 80.8315 10.3435 81.4487 10.3996C81.4487 10.3996 81.0033 10.5435 81.4197 11.2729C81.4225 11.2783 80.6289 10.7724 80.6289 10.7724Z",
    fill: "#002FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1179 17.6101L84.1552 13.8809L79.5801 13.9279C79.2206 13.9279 79.0918 14.4998 79.2402 14.7659L80.9031 17.6255C80.9612 17.7339 81.0492 17.8245 81.1573 17.8873C81.2654 17.9501 81.3894 17.9825 81.5154 17.9809C81.6414 17.9793 81.7645 17.9437 81.8709 17.8783C81.9773 17.8128 82.0628 17.7199 82.1179 17.6101Z",
    fill: "url(#paint2_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3366 14.9151C79.3366 14.9151 78.8072 14.202 79.1704 13.3767C79.1704 13.3767 79.077 13.9794 80.5261 13.9143C80.5373 13.9179 79.3366 14.9151 79.3366 14.9151Z",
    fill: "#005ECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2369 18.4521H87.5795C87.6695 18.4536 87.7582 18.4319 87.8366 18.3891C87.9151 18.3464 87.9803 18.2842 88.0258 18.209C88.0712 18.1337 88.0951 18.0481 88.0952 17.9609C88.0952 17.8737 88.0713 17.7881 88.0258 17.7128L84.9278 12.5547L81.8466 17.7924C81.8066 17.8591 81.7854 17.9347 81.7852 18.0118C81.7849 18.0889 81.8056 18.1647 81.8452 18.2316C81.8847 18.2984 81.9418 18.354 82.0105 18.3927C82.0793 18.4315 82.1574 18.4519 82.2369 18.4521Z",
    fill: "url(#paint3_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2513 18.45C81.991 18.4557 81.7342 18.391 81.5097 18.2632C81.2853 18.1353 81.102 17.9493 80.9806 17.7261C80.9806 17.7261 81.6687 18.212 82.1682 17.2401C82.1738 17.2283 82.2513 18.45 82.2513 18.45Z",
    fill: "#007FD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5424 10.3945H83.6172L88.1251 17.8774C88.1599 17.935 88.2097 17.9828 88.2695 18.0161C88.3292 18.0493 88.397 18.0667 88.4659 18.0667C88.5348 18.0667 88.6025 18.0493 88.6623 18.0161C88.7221 17.9828 88.7718 17.935 88.8067 17.8774L92.8813 10.9583C92.915 10.9009 92.9325 10.8359 92.9321 10.7698C92.9318 10.7038 92.9135 10.639 92.8792 10.5819C92.8449 10.5248 92.7957 10.4775 92.7366 10.4446C92.6775 10.4117 92.6105 10.3945 92.5424 10.3945Z",
    fill: "url(#paint4_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7981 17.8874C88.7981 17.8874 88.4909 18.4747 87.4844 18.453C87.4844 18.453 88.3667 18.1616 87.6777 17.1426C87.673 17.1354 88.7981 17.8874 88.7981 17.8874Z",
    fill: "url(#paint5_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9118 9.90625C92.9118 9.90625 93.2413 10.4067 92.922 10.8691C92.922 10.8691 93.0042 10.3976 92.3711 10.3958C92.3655 10.3958 92.9118 9.90625 92.9118 9.90625Z",
    fill: "#00F6D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3096 10.3966H92.7445C92.7907 10.3944 92.8355 10.3807 92.8746 10.3569C92.9138 10.3331 92.9459 10.2999 92.9681 10.2606C92.9902 10.2212 93.0015 10.1771 93.0009 10.1323C93.0004 10.0875 92.988 10.0436 92.9649 10.0048L87.1872 -0.179328C87.1662 -0.218844 87.1345 -0.252 87.0953 -0.27515C87.0562 -0.298299 87.0113 -0.310547 86.9654 -0.310547C86.9196 -0.310547 86.8746 -0.298299 86.8355 -0.27515C86.7964 -0.252 86.7646 -0.218844 86.7437 -0.179328L81.0873 10.0039C81.064 10.0428 81.0514 10.087 81.0508 10.132C81.0502 10.1771 81.0617 10.2215 81.084 10.2611C81.1064 10.3006 81.1389 10.3338 81.1784 10.3576C81.2179 10.3813 81.2631 10.3948 81.3096 10.3966Z",
    fill: "url(#paint6_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9904 10.0717C92.9888 10.0668 92.9869 10.062 92.9848 10.0573L92.9745 10.0328C92.9716 10.0232 92.9678 10.0138 92.9633 10.0048L92.9568 9.99302C92.9431 9.96196 92.9275 9.93174 92.9101 9.90252L87.1856 -0.179328C87.1647 -0.218844 87.1329 -0.252 87.0938 -0.27515C87.0546 -0.298299 87.0097 -0.310547 86.9639 -0.310547C86.918 -0.310547 86.8731 -0.298299 86.8339 -0.27515C86.7948 -0.252 86.763 -0.218844 86.7421 -0.179328L81.0858 10.0039C81.0631 10.0428 81.051 10.0866 81.0508 10.1313C81.0505 10.176 81.0621 10.22 81.0844 10.2591C81.1067 10.2982 81.1389 10.3311 81.1781 10.3547C81.2172 10.3783 81.2619 10.3918 81.308 10.3939H92.3704C93.0025 10.3939 92.9166 10.8817 92.9166 10.8817C92.9933 10.7616 93.0398 10.6258 93.0527 10.4852C93.0655 10.3446 93.0441 10.203 92.9904 10.0717Z",
    fill: "url(#paint7_linear_40_5242)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M81.3121 10.3979H92.7471C92.7933 10.396 92.8383 10.3825 92.8775 10.3589C92.9168 10.3352 92.9492 10.3021 92.9714 10.2628C92.9937 10.2235 93.0051 10.1793 93.0046 10.1345C93.004 10.0897 92.9916 10.0457 92.9684 10.0069L87.1898 -0.177177C87.169 -0.216728 87.1373 -0.249935 87.0982 -0.273127C87.0592 -0.29632 87.0143 -0.308594 86.9685 -0.308594C86.9227 -0.308594 86.8778 -0.29632 86.8387 -0.273127C86.7997 -0.249935 86.768 -0.216728 86.7472 -0.177177L81.0909 10.0069C81.0677 10.0457 81.0552 10.0897 81.0547 10.1345C81.0542 10.1793 81.0656 10.2235 81.0878 10.2628C81.1101 10.3021 81.1424 10.3352 81.1817 10.3589C81.221 10.3825 81.2659 10.396 81.3121 10.3979Z",
    fill: "url(#paint8_linear_40_5242)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_5242",
    x1: 83.882,
    y1: 10.3514,
    x2: 81.5186,
    y2: 12.0776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#002181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#00216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#002141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#002127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_5242",
    x1: 81.4071,
    y1: 9.87641,
    x2: 80.7429,
    y2: 13.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#002FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#002EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#002DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00299D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00216F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_5242",
    x1: 79.5315,
    y1: 13.4047,
    x2: 83.3045,
    y2: 16.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#005ECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#025CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0854C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1148B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1D389B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_5242",
    x1: 81.4554,
    y1: 17.2142,
    x2: 87.0536,
    y2: 15.1116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#007FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#007CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0073C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0064B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_5242",
    x1: 86.8833,
    y1: 18.2575,
    x2: 88.435,
    y2: 9.17979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00AED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ABD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00A1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0090BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0086B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_5242",
    x1: 87.4853,
    y1: 17.7978,
    x2: 88.7981,
    y2: 17.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#00AED3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_5242",
    x1: 83.7605,
    y1: 4.83219,
    x2: 92.9436,
    y2: 10.3025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DF2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6BF5D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#87F6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8AF6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#76F6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#43F6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#1FF6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#08F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_5242",
    x1: 87.0549,
    y1: -0.308732,
    x2: 87.0549,
    y2: 10.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00F6D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#00F6D4",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#00F6D4",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00F6D4",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00F6D4",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#00F6D4",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00F6D4",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00F6D4",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_5242",
    x1: 83.7631,
    y1: 4.83343,
    x2: 92.9471,
    y2: 10.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7BF6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#91F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#93F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6DF6D4",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#47F6D4",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#28F6D4",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#12F6D4",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#05F6D4",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00F6D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00F6D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#00F6D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F6D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 23,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt3FaceLogo1);
export default __webpack_public_path__ + "static/media/Int3face_logo-1.794faa17.svg";
export { ForwardRef as ReactComponent };